import React from 'react'

import {Button, TextField} from "@mui/material"
// @ts-ignore
import ColorSelector, {colorsGroups} from "./color/color"

// const debug = false
const debug = "AddForm"

type Props = {
    editData?   : any
    onDone?     : () => void
}

export default class AddForm extends React.PureComponent<Props> {

    private name        : string
    private coordinates  : string
    private radius       : string
    private color        : string

    constructor(props: Props) {
        super(props)

        this.name        = _.get(props, 'editData.name', '')
        this.coordinates = _.get(props, 'editData.coordinates', '')
        this.radius      = _.get(props, 'editData.radius') ? String(props.editData.radius) : ''
        this.color       = _.get(props, 'editData.customColor', '')
    }

    onNameInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        debug && console.log(debug, "onNameInputChange", e.target.value, e)
        this.name = e.target.value
    }

    onCoordinatesInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        debug && console.log(debug, "onCoordinatesInputChange", e.target.value, e)
        this.coordinates = e.target.value
    }

    onRadiusInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        debug && console.log(debug, "onRadiusInputChange", e.target.value, e)
        this.radius = e.target.value
    }

    onColorChange = (color: string) => {
        debug && console.log(debug, "onColorChange", color)
        this.color = color
    }

    onSubmit = () => {
        debug && console.log(debug, "onSubmit", this.coordinates, this.radius)

        const pointData = {
            name        : this.name,
            coordinates : this.coordinates,
            radius      : parseInt(this.radius),
            customColor : this.color || colorsGroups[0][0],
            isCustom    : true
        }

        if (this.props.editData) {
            window.bus.triggerEvent("update-point", this.props.editData.id, pointData)
            this.props.onDone?.()
        } else {
            window.bus.triggerEvent("add-points", [pointData])
        }
    }

    render() {
        debug && console.log(debug, "render")

        return (
            <>
                <div className="add-panel-row">
                    <TextField label        = "Название"
                               variant      = "outlined"
                               defaultValue = {this.name}
                               onChange     = {this.onNameInputChange}/>
                </div>
                <div className="add-panel-row">
                    <TextField label        = "Координаты"
                               variant      = "outlined"
                               defaultValue = {this.coordinates}
                               onChange     = {this.onCoordinatesInputChange}/>
                </div>
                <div className="add-panel-row">
                    <TextField label        = "Радиус"
                               variant      = "outlined"
                               defaultValue = {this.radius}
                               onChange     = {this.onRadiusInputChange}/>
                </div>

                <ColorSelector initialColor={this.color || undefined} onChange={this.onColorChange}/>

                <div className="add-panel-row">
                    <Button variant="contained" onClick={this.onSubmit}>{this.props.editData ? 'Подтвердить' : 'Добавить'}</Button>
                </div>
            </>
        )
    }
}
